export default __webpack_public_path__ + "static/media/guard2.e9e7b434.png";